import React from 'react';
import { number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import withRouter from 'utils/withRouter';
import { createStructuredSelector } from 'reselect';

import Typography from 'ravenjs/lib/Typography';
import { get } from 'ravenjs/utils/lodash';

import { DEFAULT_COLORS } from 'constants/colors';
import withPublicContent from 'components/PublicContent/PublicContentHOC';
import { selectors as userSelectors } from 'modules/user';

const AppDisclaimer = props => {
    const { partnerSettings } = props;
    const disclaimerText = get(partnerSettings, 'disclaimerText', '');

    const renderDisclaimer = () => {
        if (disclaimerText) {
            return (
                <Typography
                    id="appDisclaimer"
                    color={DEFAULT_COLORS.PLACEHOLDER}
                    className="disclaimerText"
                    fontStyle="italic"
                    fontSize="0.6875rem !important"
                    gutterBottom="0 !important"
                    gutterTop="0 !important"
                    padding="1rem 1rem 3.5rem 1rem"
                    type="paragraph"
                >
                    {disclaimerText}
                </Typography>
            );
        } else {
            return null;
        }
    };

    return renderDisclaimer();
};

AppDisclaimer.propTypes = {
    userCompany: shape({
        disclaimerText: string,
        partnerId: number,
    }),
};

AppDisclaimer.defaultProps = {
    partnerSettings: {
        disclaimerText: '',
    },
    userCompany: {
        partnerId: 0,
    },
};

const mapStateToProps = createStructuredSelector({
    partnerSettings: userSelectors.getPartnerSettings,
    userCompany: userSelectors.getUserCompany,
});

export { AppDisclaimer as AppDisclaimerUnwrapped };
export default withPublicContent(withRouter(connect(mapStateToProps)(AppDisclaimer)));
